import { Outlet, useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "./Header";
import { BottomNav } from "./BottomNav";
import { InstallPrompt } from "./InstallPrompt";
import { AdSlot } from "./Ads";
import { CATEGORIES } from "@/lib/api";

function Footer() {
  return (
    <footer className="mt-16 bg-[#0b0f17] text-slate-300">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <p className="font-serif-display text-3xl font-black text-white">Notícia<span className="text-primary">365</span></p>
          <p className="mt-3 text-sm text-slate-400">O maior agregador de notícias de Moçambique. Atualizado ao minuto, a partir dos principais jornais do país.</p>
        </div>
        <div>
          <p className="mb-3 font-mono-meta text-xs uppercase tracking-widest text-primary">Categorias</p>
          <div className="grid grid-cols-2 gap-2 text-sm">
            {CATEGORIES.map((c) => <Link key={c.slug} to={`/categoria/${c.slug}`} data-testid={`footer-cat-${c.slug}`} className="hover:text-white">{c.name}</Link>)}
          </div>
        </div>
        <div className="text-sm">
          <p className="mb-3 font-mono-meta text-xs uppercase tracking-widest text-primary">Notícia 365</p>
          <Link to="/fontes" className="block hover:text-white">Fontes</Link>
          <Link to="/guardados" className="block hover:text-white">Guardados</Link>
          <Link to="/admin" data-testid="footer-admin-link" className="block hover:text-white">Área reservada</Link>
        </div>
      </div>
      <p className="border-t border-white/10 py-5 text-center text-xs text-slate-500">© {new Date().getFullYear()} Notícia 365 · Os conteúdos agregados pertencem às respetivas fontes</p>
    </footer>
  );
}

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen bg-background">
      <AdSlot slot="body_top" />
      <Header />
      <main className="pb-24 lg:pb-0">
        <Outlet />
      </main>
      <AdSlot slot="footer" className="mx-auto max-w-7xl px-4 py-6" />
      <Footer />
      <InstallPrompt />
      <BottomNav />
    </div>
  );
}
